<template>
    <div v-show="isLoggedIn">
        <div v-show="messageDialog" class="itb-overlay"></div>
        <TermsAndCondition
            :visible="messageDialog"
            @close="messageDialog = false"
        />

        <div class="itb-saved-carts container mt-0">
            <div class="row" v-if="message">
                <div
                    class="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3 pt-3"
                >
                    <div
                        :class="'alert itb-alert alert-' + message.type"
                        role="alert"
                        v-if="message"
                    >
                        {{ message.text }}
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="appParams && appParams.staticTranslations"
            id="itb-address-page"
        >
            <h2 class="itb-cart-title" style="margin-top: 78px">
                {{ appParams.staticTranslations["general.settings"] }}
            </h2>
            <div class="container">
                <div>
                    <div class="itb-form-fields-cart">
                        <div>
                            <form
                                id="cartform"
                                class="container"
                                @submit.prevent="save"
                            >
                                <div class="row">
                                    <div class="col bill-col">
                                        <h3 id="itb-cart-bill-info">
                                            {{
                                                appParams.staticTranslations[
                                                    "carts.billing_details"
                                                ]
                                            }}
                                        </h3>
                                        <label
                                            for="itb-cart-form-vat"
                                            class="itb-cart-mt"
                                            >{{
                                                appParams.staticTranslations[
                                                    "clients.vat"
                                                ]
                                            }}</label
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="itb-cart-form-vat"
                                            :placeholder="
                                                appParams.staticTranslations[
                                                    'clients.vat_placeholder'
                                                ]
                                            "
                                            v-model.trim="vat"
                                            disabled
                                        />
                                        <label
                                            for="itb-cart-form-bill-name"
                                            class="itb-cart-mt"
                                            :class="{
                                                'itb-label-error':
                                                    $v.bill_name.$error,
                                            }"
                                            >{{
                                                appParams.staticTranslations[
                                                    "clients.bill_name"
                                                ]
                                            }}
                                        </label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="itb-cart-form-bill-name"
                                            :placeholder="
                                                appParams.staticTranslations[
                                                    'clients.bill_name_placeholder'
                                                ]
                                            "
                                            v-model.trim="bill_name"
                                            @input="$v.bill_name.$touch()"
                                            :class="{
                                                'itb-field-error':
                                                    $v.bill_name.$error,
                                            }"
                                            ref="bill_name"
                                            disabled
                                        />
                                        <div v-if="$v.bill_name.$dirty">
                                            <p
                                                class="itb-error-message mb-0"
                                                v-if="!$v.bill_name.required"
                                                aria-live="assertive"
                                            >
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                        "carts.field_must_not_be_empty"
                                                    ]
                                                }}
                                            </p>
                                        </div>

                                        <label
                                            for="itb-cart-form-bill-company"
                                            class="itb-cart-mt"
                                            :class="{
                                                'itb-label-error':
                                                    $v.bill_company.$error,
                                            }"
                                            >{{
                                                appParams.staticTranslations[
                                                    "clients.bill_company"
                                                ]
                                            }}</label
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="itb-cart-form-bill-company"
                                            :placeholder="
                                                appParams.staticTranslations[
                                                    'clients.bill_company_placeholder'
                                                ]
                                            "
                                            v-model.trim="bill_company"
                                            @input="$v.bill_company.$touch()"
                                            :class="{
                                                'itb-field-error':
                                                    $v.bill_company.$error,
                                            }"
                                            ref="bill_company"
                                            disabled
                                        />
                                        <div v-if="$v.bill_company.$dirty">
                                            <p
                                                class="itb-error-message mb-0"
                                                v-if="!$v.bill_company.required"
                                                aria-live="assertive"
                                            >
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                        "carts.field_must_not_be_empty"
                                                    ]
                                                }}
                                            </p>
                                        </div>
                                        <label
                                            for="itb-cart-form-bill-street"
                                            class="itb-cart-mt"
                                            :class="{
                                                'itb-label-error':
                                                    $v.bill_street.$error,
                                            }"
                                            >{{
                                                appParams.staticTranslations[
                                                    "clients.bill_street"
                                                ]
                                            }}</label
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="itb-cart-form-bill-street"
                                            :placeholder="
                                                appParams.staticTranslations[
                                                    'clients.bill_street_placeholder'
                                                ]
                                            "
                                            v-model.trim="bill_street"
                                            @input="$v.bill_street.$touch()"
                                            :class="{
                                                'itb-field-error':
                                                    $v.bill_street.$error,
                                            }"
                                            ref="bill_street"
                                            disabled
                                        />
                                        <div v-if="$v.bill_street.$dirty">
                                            <p
                                                class="itb-error-message mb-0"
                                                v-if="!$v.bill_street.required"
                                                aria-live="assertive"
                                            >
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                        "carts.field_must_not_be_empty"
                                                    ]
                                                }}
                                            </p>
                                        </div>
                                        <div class="row itb-city-postcode">
                                            <div class="col-lg-8">
                                                <label
                                                    for="itb-cart-form-bill-city"
                                                    class="itb-cart-mt"
                                                    :class="{
                                                        'itb-label-error':
                                                            $v.bill_city.$error,
                                                    }"
                                                    >{{
                                                        appParams
                                                            .staticTranslations[
                                                            "clients.bill_city"
                                                        ]
                                                    }}</label
                                                >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    id="itb-cart-form-bill-city"
                                                    :placeholder="
                                                        appParams
                                                            .staticTranslations[
                                                            'clients.bill_city_placeholder'
                                                        ]
                                                    "
                                                    v-model.trim="bill_city"
                                                    @input="
                                                        $v.bill_city.$touch()
                                                    "
                                                    :class="{
                                                        'itb-field-error':
                                                            $v.bill_city.$error,
                                                    }"
                                                    ref="bill_city"
                                                    disabled
                                                />
                                                <div v-if="$v.bill_city.$dirty">
                                                    <p
                                                        class="itb-error-message mb-0"
                                                        v-if="
                                                            !$v.bill_city
                                                                .required
                                                        "
                                                        aria-live="assertive"
                                                    >
                                                        {{
                                                            appParams
                                                                .staticTranslations[
                                                                "carts.field_must_not_be_empty"
                                                            ]
                                                        }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-lg-4">
                                                <label
                                                    for="itb-cart-form-bill-postcode"
                                                    class="itb-cart-mt"
                                                    :class="{
                                                        'itb-label-error':
                                                            $v.bill_postcode
                                                                .$error,
                                                    }"
                                                    >{{
                                                        appParams
                                                            .staticTranslations[
                                                            "clients.bill_postcode"
                                                        ]
                                                    }}</label
                                                >
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    id="itb-cart-form-bill-postcode"
                                                    :placeholder="
                                                        appParams
                                                            .staticTranslations[
                                                            'clients.bill_postcode_placeholder'
                                                        ]
                                                    "
                                                    v-model.trim="bill_postcode"
                                                    @input="
                                                        $v.bill_postcode.$touch()
                                                    "
                                                    :class="{
                                                        'itb-field-error':
                                                            $v.bill_postcode
                                                                .$error,
                                                    }"
                                                    ref="bill_postcode"
                                                    disabled
                                                />
                                                <div
                                                    v-if="
                                                        $v.bill_postcode.$dirty
                                                    "
                                                >
                                                    <p
                                                        class="itb-error-message mb-0"
                                                        v-if="
                                                            !$v.bill_postcode
                                                                .required
                                                        "
                                                        aria-live="assertive"
                                                    >
                                                        {{
                                                            appParams
                                                                .staticTranslations[
                                                                "carts.field_must_not_be_empty"
                                                            ]
                                                        }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <label
                                            for="itb-cart-form-bill-country"
                                            class="itb-cart-mt"
                                            :class="{
                                                'itb-label-error':
                                                    $v.bill_country.$error,
                                            }"
                                            >{{
                                                appParams.staticTranslations[
                                                    "clients.bill_country"
                                                ]
                                            }}</label
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="itb-cart-form-bill-country"
                                            :placeholder="
                                                appParams.staticTranslations[
                                                    'clients.bill_country_placeholder'
                                                ]
                                            "
                                            v-model.trim="bill_country"
                                            @input="$v.bill_country.$touch()"
                                            :class="{
                                                'itb-field-error':
                                                    $v.bill_country.$error,
                                            }"
                                            ref="bill_country"
                                            disabled
                                        />
                                        <div v-if="$v.bill_country.$dirty">
                                            <p
                                                class="itb-error-message mb-0"
                                                v-if="!$v.bill_country.required"
                                                aria-live="assertive"
                                            >
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                        "carts.field_must_not_be_empty"
                                                    ]
                                                }}
                                            </p>
                                        </div>
                                        <label
                                            for="itb-cart-form-email"
                                            class="itb-cart-mt"
                                            :class="{
                                                'itb-label-error':
                                                    $v.email.$error,
                                            }"
                                            >{{
                                                appParams.staticTranslations[
                                                    "clients.email"
                                                ]
                                            }}</label
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="itb-cart-form-email"
                                            :placeholder="
                                                appParams.staticTranslations[
                                                    'clients.email_placeholder'
                                                ]
                                            "
                                            v-model.trim="email"
                                            @input="$v.email.$touch()"
                                            :class="{
                                                'itb-field-error':
                                                    $v.email.$error,
                                            }"
                                            ref="email"
                                            disabled
                                        />
                                        <div v-if="$v.email.$dirty">
                                            <p
                                                class="itb-error-message mb-0"
                                                v-if="!$v.email.required"
                                                aria-live="assertive"
                                            >
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                        "carts.field_must_not_be_empty"
                                                    ]
                                                }}
                                            </p>
                                            <p
                                                class="itb-error-message mb-0"
                                                v-if="!$v.email.email"
                                                aria-live="assertive"
                                            >
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                        "carts.email_must_be_valid"
                                                    ]
                                                }}
                                            </p>
                                        </div>
                                        <label
                                            for="itb-cart-form-phone"
                                            class="itb-cart-mt"
                                            :class="{
                                                'itb-label-error':
                                                    $v.phone.$error,
                                            }"
                                            >{{
                                                appParams.staticTranslations[
                                                    "clients.phone"
                                                ]
                                            }}</label
                                        >
                                        <input
                                            type="tel"
                                            class="form-control"
                                            id="itb-cart-form-phone"
                                            :placeholder="
                                                appParams.staticTranslations[
                                                    'clients.phone_placeholder'
                                                ]
                                            "
                                            v-model.trim="phone"
                                            @input="$v.phone.$touch()"
                                            :class="{
                                                'itb-field-error':
                                                    $v.phone.$error,
                                            }"
                                            ref="phone"
                                            disabled
                                        />
                                        <div v-if="$v.phone.$dirty">
                                            <p
                                                class="itb-error-message mb-0"
                                                v-if="!$v.phone.required"
                                                aria-live="assertive"
                                            >
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                        "carts.field_must_not_be_empty"
                                                    ]
                                                }}
                                            </p>
                                            <p
                                                class="itb-error-message mb-0"
                                                v-if="!$v.phone.minLength"
                                                aria-live="assertive"
                                            >
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                        "carts.phone_must_have_minimum"
                                                    ]
                                                }}
                                                {{
                                                    $v.phone.$params.minLength
                                                        .min
                                                }}
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                        "carts.digits"
                                                    ]
                                                }}
                                            </p>
                                            <p
                                                class="itb-error-message mb-0"
                                                v-if="!$v.phone.phoneSymbols"
                                                aria-live="assertive"
                                            >
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                        "carts.phone_must_be_numeric"
                                                    ]
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                    <!-- delivery column -->
                                    <div class="col delivery-col">
                                        <div class="row">
                                            <div class="col-lg">
                                                <h3 id="itb-cart-delivery-info">
                                                    {{
                                                        appParams
                                                            .staticTranslations[
                                                            "carts.delivery_address"
                                                        ]
                                                    }}
                                                </h3>
                                            </div>
                                        </div>
                                        <div class="itb-carts-saved-addresses">
                                            <label class="itb-cart-mt">{{
                                                appParams.staticTranslations[
                                                    "carts.saved_addresses"
                                                ]
                                            }}</label>
                                            <div v-if="addresses.length > 0">
                                                <button
                                                    type="button"
                                                    class="btn btn-light mr-1"
                                                    v-for="(
                                                        address, index
                                                    ) in addresses"
                                                    :key="address.id"
                                                    @click="
                                                        changeAddress(index)
                                                    "
                                                    :class="[
                                                        chosenAddress == index
                                                            ? 'itb-chosen-address'
                                                            : '',
                                                    ]"
                                                >
                                                    {{ index + 1 }}
                                                </button>
                                            </div>
                                            <p v-else>
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                        "carts.no_addresses_available_settings"
                                                    ]
                                                }}
                                            </p>
                                        </div>
                                        <div v-if="addresses.length > 0">
                                            <label
                                                for="itb-cart-form-delivery-name"
                                                class="itb-cart-mt"
                                                >{{
                                                    appParams
                                                        .staticTranslations[
                                                        "clients.delivery_name"
                                                    ]
                                                }}</label
                                            >
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="itb-cart-form-delivery-name"
                                                :placeholder="
                                                    appParams
                                                        .staticTranslations[
                                                        'clients.delivery_name_placeholder'
                                                    ]
                                                "
                                                v-model.trim="delivery_name"
                                                @input="
                                                    $v.delivery_name.$touch()
                                                "
                                                ref="delivery_name"
                                                disabled
                                            />

                                            <label
                                                for="itb-cart-form-delivery-company"
                                                class="itb-cart-mt"
                                                >{{
                                                    appParams
                                                        .staticTranslations[
                                                        "clients.delivery_company"
                                                    ]
                                                }}</label
                                            >
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="itb-cart-form-delivery-company"
                                                :placeholder="
                                                    appParams
                                                        .staticTranslations[
                                                        'clients.delivery_company_placeholder'
                                                    ]
                                                "
                                                v-model.trim="delivery_company"
                                                @input="
                                                    $v.delivery_company.$touch()
                                                "
                                                ref="delivery_company"
                                                disabled
                                            />

                                            <label
                                                for="itb-cart-form-delivery-street"
                                                class="itb-cart-mt"
                                                >{{
                                                    appParams
                                                        .staticTranslations[
                                                        "clients.delivery_street"
                                                    ]
                                                }}</label
                                            >
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="itb-cart-form-delivery-street"
                                                :placeholder="
                                                    appParams
                                                        .staticTranslations[
                                                        'clients.delivery_street_placeholder'
                                                    ]
                                                "
                                                v-model.trim="delivery_street"
                                                @input="
                                                    $v.delivery_street.$touch()
                                                "
                                                ref="delivery_street"
                                                disabled
                                            />

                                            <div class="row itb-city-postcode">
                                                <div class="col-lg-8">
                                                    <label
                                                        for="itb-cart-form-delivery-city"
                                                        class="itb-cart-mt"
                                                        >{{
                                                            appParams
                                                                .staticTranslations[
                                                                "clients.delivery_city"
                                                            ]
                                                        }}</label
                                                    >
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        id="itb-cart-form-delivery-city"
                                                        :placeholder="
                                                            appParams
                                                                .staticTranslations[
                                                                'clients.delivery_city_placeholder'
                                                            ]
                                                        "
                                                        v-model.trim="
                                                            delivery_city
                                                        "
                                                        @input="
                                                            $v.delivery_city.$touch()
                                                        "
                                                        ref="delivery_city"
                                                        disabled
                                                    />
                                                </div>
                                                <div class="col-lg-4">
                                                    <label
                                                        for="itb-cart-form-delivery-postcode"
                                                        class="itb-cart-mt"
                                                        >{{
                                                            appParams
                                                                .staticTranslations[
                                                                "clients.delivery_postcode"
                                                            ]
                                                        }}</label
                                                    >
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        id="itb-cart-form-delivery-postcode"
                                                        :placeholder="
                                                            appParams
                                                                .staticTranslations[
                                                                'clients.delivery_postcode_placeholder'
                                                            ]
                                                        "
                                                        v-model.trim="
                                                            delivery_postcode
                                                        "
                                                        @input="
                                                            $v.delivery_postcode.$touch()
                                                        "
                                                        ref="delivery_postcode"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <label
                                                for="itb-cart-form-delivery-country"
                                                class="itb-cart-mt"
                                                >{{
                                                    appParams
                                                        .staticTranslations[
                                                        "clients.delivery_country"
                                                    ]
                                                }}</label
                                            >
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="itb-cart-form-delivery-country"
                                                :placeholder="
                                                    appParams
                                                        .staticTranslations[
                                                        'clients.delivery_country_placeholder'
                                                    ]
                                                "
                                                v-model.trim="delivery_country"
                                                @input="
                                                    $v.delivery_country.$touch()
                                                "
                                                ref="delivery_country"
                                                disabled
                                            />

                                            <label
                                                for="itb-cart-form-delivery_email"
                                                class="itb-cart-mt"
                                                >{{
                                                    appParams
                                                        .staticTranslations[
                                                        "clients.delivery_email"
                                                    ]
                                                }}</label
                                            >
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="itb-cart-form-delivery_email"
                                                :placeholder="
                                                    appParams
                                                        .staticTranslations[
                                                        'clients.delivery_email_placeholder'
                                                    ]
                                                "
                                                v-model.trim="delivery_email"
                                                @input="
                                                    $v.delivery_email.$touch()
                                                "
                                                ref="delivery_email"
                                                disabled
                                            />

                                            <label
                                                for="itb-cart-form-delivery_phone"
                                                class="itb-cart-mt"
                                                >{{
                                                    appParams
                                                        .staticTranslations[
                                                        "clients.delivery_phone"
                                                    ]
                                                }}</label
                                            >
                                            <input
                                                type="tel"
                                                class="form-control"
                                                id="itb-cart-form-delivery_phone"
                                                :placeholder="
                                                    appParams
                                                        .staticTranslations[
                                                        'clients.delivery_phone_placeholder'
                                                    ]
                                                "
                                                v-model.trim="delivery_phone"
                                                @input="
                                                    $v.delivery_phone.$touch()
                                                "
                                                ref="delivery_phone"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div
                                    id="itb-agree-terms-wrapper"
                                    class="text-center itb-inline-checkbox-wrapper"
                                    :class="agree_terms ? 'itb-active' : ''"
                                    hidden
                                >
                                    <label
                                        for="itb-cart-agree-terms"
                                        class="itb-inline-checkbox-label"
                                        :class="{
                                            'itb-label-error':
                                                $v.agree_terms.$error,
                                        }"
                                    >
                                        <input
                                            type="checkbox"
                                            id="itb-cart-agree-terms"
                                            v-model.trim="agree_terms"
                                            @input="$v.agree_terms.$touch()"
                                            :class="{
                                                'itb-field-error':
                                                    $v.agree_terms.$error,
                                            }"
                                            ref="agree_terms"
                                        />
                                        <span class="itb-checkmark"></span>
                                        {{
                                            appParams.staticTranslations[
                                                "carts.agree_terms"
                                            ]
                                        }}
                                        <a
                                            href="javascript:void(0)"
                                            @click="showTerms"
                                        >
                                            {{
                                                appParams.staticTranslations[
                                                    "carts.terms"
                                                ]
                                            }}
                                        </a>
                                    </label>

                                    <div v-if="$v.agree_terms.$dirty">
                                        <p
                                            class="itb-error-message mb-0"
                                            v-if="!$v.agree_terms.sameAs"
                                            aria-live="assertive"
                                        >
                                            {{
                                                appParams.staticTranslations[
                                                    "carts.must_agree_terms"
                                                ]
                                            }}
                                        </p>
                                    </div>
                                </div>
                                <div class="itb-submit-btn-wrapper" hidden>
                                    <button
                                        type="submit"
                                        class="btn btn-primary itb-add-to-basket"
                                        :disabled="submitStatus"
                                        style="margin-bottom: 60px"
                                    >
                                        {{
                                            appParams.staticTranslations[
                                                "general.update_address"
                                            ]
                                        }}&nbsp;
                                    </button>
                                </div>
                                <p class="text-center mt-5 mb-5">
                                    <span>
                                        {{
                                            appParams.staticTranslations[
                                                "general.update_request"
                                            ] + ":"
                                        }} </span
                                    >&#32;<a
                                        :href="
                                            'mailto:' +
                                            appParams.general_email +
                                            '?Subject=' +
                                            appParams.staticTranslations[
                                                'general.email_subject'
                                            ]
                                        "
                                        itemprop="email"
                                        >{{ appParams.general_email }}</a
                                    >
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
    required,
    email,
    maxLength,
    numeric,
    minLength,
    sameAs,
    helpers,
} from "vuelidate/lib/validators";
const phoneSymbols = helpers.regex(
    "phoneSymbols",
    /^([+]?[\s]?[0-9]+)?([\s]?[0-9])+$/
);

import TermsAndCondition from "../components/TermsAndCondition";

export default {
    data() {
        return {
            // heroCards: [],
            pageParams: [],
            bill_name: null,
            bill_company: null,
            bill_street: null,
            bill_city: null,
            bill_postcode: null,
            bill_country: null,
            email: null,
            phone: null,
            vat: null,
            delivery_email: null,
            delivery_phone: null,
            delivery_name: null,
            delivery_company: null,
            delivery_street: null,
            delivery_city: null,
            delivery_postcode: null,
            delivery_country: null,
            submitStatus: false,
            agree_terms: false,
            message: null,
            updatedProfile: {},
            messageDialog: false,
            addresses: [],
            chosenAddress: 0,
            show_address_warning: false,
            previousChosenAddress: 0,
        };
    },
    mounted() {
        axios
            .get("/getAddressPage")
            .then((response) => {
                // this.heroCards = response.data.heroCards;
                this.pageParams = response.data.params;
                this.setPageParams(this.pageParams);
            })
            .catch((error) => {
                console.log(error);
            });
    },
    created() {
        // when page is accessed without being logged in, it will redirect to home
        this.logRedirect();
        this.getCurrentLanguage();
        // executes refreshClientData in callback
        // this.refreshClientData();
    },

    components: {
        TermsAndCondition,
    },
    computed: {
        ...mapGetters({
            appParams: "getAppParams",
            isLoggedIn: "getClientLogged",
            profile: "getClientProfile",
        }),
    },
    validations: {
        bill_name: {
            required,
        },
        bill_company: {
            required,
        },
        bill_street: {
            required,
        },
        bill_city: {
            required,
        },
        bill_postcode: {
            required,
        },
        bill_country: {
            required,
        },
        email: {
            required,
            email,
        },
        phone: {
            required,
            minLength: minLength(7),
            phoneSymbols,
        },
        agree_terms: {
            required,
            sameAs: sameAs(() => true),
        },
    },
    methods: {
        ...mapActions(["setPageParams", "setFormParams"]),
        logRedirect() {
            if (!this.isLoggedIn) {
                if (this.$route.path != "/") {
                    this.$router.push("/");
                }
            }
        },

        async save() {
            var toData = {
                bill_name: this.bill_name,
                bill_company: this.bill_company,
                bill_street: this.bill_street,
                bill_city: this.bill_city,
                bill_postcode: this.bill_postcode,
                bill_country: this.bill_country,
                email: this.email,
                phone: this.phone,
                vat: this.vat,
                client_id: this.profile.id,
            };
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.submitStatus = false;
                for (let key in Object.keys(this.$v)) {
                    const input = Object.keys(this.$v)[key];
                    if (input.includes("$")) return false;
                    if (this.$v[input].$error) {
                        this.$refs[input].scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                        });
                        break;
                    }
                }
            } else {
                this.submitStatus = "true";
                await axios
                    .post("/updateAddress", toData)
                    .then((response) => {
                        this.message = {
                            text: this.appParams.staticTranslations[
                                "carts.form_sent_succesfully"
                            ],
                            type: "success",
                        };
                        this.$v.$reset();

                        this.agree_terms = false;
                        this.chosenAddress = 0;
                        this.show_address_warning = false;
                        this.refreshClientData();
                        this.scrollToTop();
                        setTimeout(() => {
                            this.message = null;
                        }, 3000);
                    })
                    .catch((error) => {
                        console.log(error);
                        this.message = {
                            text: this.appParams.staticTranslations[
                                "carts.form_error"
                            ],
                            type: "danger",
                        };
                        setTimeout(() => {
                            this.message = null;
                        }, 3000);
                    });
                setTimeout(() => {
                    this.submitStatus = false;
                }, 500);
            }
        },

        getCurrentLanguage() {
            axios
                .get("/getCurrentLanguage")
                .then((response) => {
                    this.currentLanguage = response.data;
                    this.refreshClientData();
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        refreshClientData() {
            var id = {
                idNumber: this.profile.id,
                language: this.currentLanguage,
                isClientRepresentative: this.profile.isClientRepresentative,
                email: this.profile.email,
            };
            axios
                .post("/api/auth/refresh-client-info", id)
                .then((response) => {
                    this.updatedProfile = response.data;
                    this.addresses = this.updatedProfile.addresses;

                    this.bill_name = this.updatedProfile.name
                        ? String(this.updatedProfile.name)
                        : "";
                    this.bill_company = this.updatedProfile.bill_company
                        ? String(this.updatedProfile.bill_company)
                        : "";
                    this.bill_street = this.updatedProfile.bill_street
                        ? String(this.updatedProfile.bill_street)
                        : "";
                    this.bill_city = this.updatedProfile.bill_city
                        ? String(this.updatedProfile.bill_city)
                        : "";
                    this.bill_postcode = this.updatedProfile.bill_postcode
                        ? String(this.updatedProfile.bill_postcode)
                        : "";
                    this.bill_country = this.updatedProfile.initialCountry.text
                        ? String(this.updatedProfile.initialCountry.text)
                        : "";
                    this.email = this.updatedProfile.email
                        ? String(this.updatedProfile.email)
                        : "";
                    this.phone = this.updatedProfile.phone
                        ? String(this.updatedProfile.phone)
                        : "";
                    this.vat = this.updatedProfile.vat
                        ? String(this.updatedProfile.vat)
                        : "";

                    if (this.addresses.length > 0) {
                        this.changeAddress(0);
                    } else {
                        this.delivery_email = "";
                        this.delivery_phone = "";
                        this.delivery_name = "";
                        this.delivery_company = "";
                        this.delivery_street = "";
                        this.delivery_city = "";
                        this.delivery_country = "";
                        this.delivery_postcode = "";
                        this.show_address_warning = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        showTerms() {
            this.messageDialog = !this.messageDialog;
        },
        changeAddress(index) {
            this.chosenAddress = index;

            this.delivery_email = this.addresses[this.chosenAddress].email
                ? this.addresses[this.chosenAddress].email
                : "";
            this.delivery_email = String(this.delivery_email);

            this.delivery_phone = this.addresses[this.chosenAddress].phone
                ? this.addresses[this.chosenAddress].phone
                : "";
            this.delivery_phone = String(this.delivery_phone);

            this.delivery_name = this.addresses[this.chosenAddress].name
                ? this.addresses[this.chosenAddress].name
                : "";
            this.delivery_name = String(this.delivery_name);

            this.delivery_company = this.addresses[this.chosenAddress].company
                ? this.addresses[this.chosenAddress].company
                : "";
            this.delivery_company = String(this.delivery_company);

            this.delivery_street = this.addresses[this.chosenAddress].street
                ? this.addresses[this.chosenAddress].street
                : "";
            this.delivery_street = String(this.delivery_street);

            this.delivery_city = this.addresses[this.chosenAddress].city
                ? this.addresses[this.chosenAddress].city
                : "";
            this.delivery_city = String(this.delivery_city);

            this.delivery_country = this.addresses[this.chosenAddress]
                .initialCountry.text
                ? this.addresses[this.chosenAddress].initialCountry.text
                : "";
            this.delivery_country = String(this.delivery_country);

            this.delivery_postcode = this.addresses[this.chosenAddress].postcode
                ? this.addresses[this.chosenAddress].postcode
                : "";
            this.delivery_postcode = String(this.delivery_postcode);
        },
    },
};
</script>
